import gql from "graphql-tag";
import { ORDER_FOR_GA_PURCHASE } from "@src/queries/fragment_order_for_ga_purchase";

export const ORDER = gql`
  ${ORDER_FOR_GA_PURCHASE}
  fragment order on Order{
    ...orderForGaPurchase
    isMgs
    isKycChecked
    kycUrl
    status
    statusDisplay
    number
    paymentStatus
    paymentStatusDisplay
    userEmail
    paymentSessionId
    simplInitiateUrl
    paymentRedirectionUrl
    earnPointEvent {
      amount
    }
    expectedArrivalDateInIndia
    # check waiting payment
    # https://github.com/velymonkeys/velymonkeys/blob/74c6d7da82ed9a4b51f9973f34e27d728b5e6a8f/saleor/mp_order/views.py#L90
    payments {
      id
      isActive
      chargeStatus
      gateway
      capturedAmount {
        amount
      }
      transactions {
        kind
        isSuccess
      }
    }
    total {
      # for Payment Amount
      gross {
        amount
      }
    }
    billingAddress {
      id
      firstName
      lastName
      streetAddress1
      postalCode
      phone
    }
    shippingAddress {
      id
      firstName
      lastName
      streetAddress1
      streetAddress2
      city
      countryArea
      postalCode
      phone
    }
    fulfillments {
      fulfillmentOrder
      status
      statusDisplay
      # /en/order/tracking?tracking_number=
      trackingNumber
      lines {
        orderLine {
          productName
          quantity
        }
      }
    }
  }
`;

export const ORDER_PAYMENT_COMPLETE = gql`
  ${ORDER}
  mutation orderPaymentComplete(
    $orderId: ID!,
    $paymentId: ID!,
    $paymentToken: String
  ) {
    orderPaymentComplete(
      orderId: $orderId,
      paymentId: $paymentId,
      paymentToken: $paymentToken
    ) {
      errors {
        field
        message
      }
      order {
        ...order
      }
      payment {
        id
      }
    }
  }
`;


export const ORDER_BY_TOKEN = gql`
  ${ORDER}
  query orderByToken($token: String!) {
    orderByToken(token: $token) {
      ...order
    }
  }
`;

export const CANCEL_ORDER = gql`
  mutation orderCancelByCustomer($id: ID!) {
    orderCancelByCustomer(id: $id) {
      errors {
        message
      }
      order {
        id
      }
    }
  }
`;
